export class RoleAvailabilityModel {roleHashId: any;
  customerHashId: any;

  public roleAvailabilityHashId: string;
  public internalRoleName: string;
  public presentationName: string;
  public entity: string;
  public isDefault: boolean;
  public roleType: string;
  public isChecked: boolean=false;

  constructor() {

  }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/roleavailability/models/roleavailability.model.ts